import { Pipe, PipeTransform } from '@angular/core';
import { CardRequestStatusesEnum } from '@lib/enums';
import { Optional } from '@lib/interfaces';

@Pipe({
    standalone: true,
    name: 'cardRequestStatus',
})
export class CardRequestStatusPipe implements PipeTransform {
    public transform(value: Optional<CardRequestStatusesEnum>): string {
        switch (value) {
            case CardRequestStatusesEnum.COMPLETED:
                return 'Completed';
            case CardRequestStatusesEnum.REJECTED:
                return 'Rejected';
            case CardRequestStatusesEnum.PENDING:
                return 'Pending';
            case CardRequestStatusesEnum.READY_FOR_PICKUP:
                return 'Ready for pickup';
            default:
                return '';
        }
    }
}
